import { AdminConsoleApiConfiguration } from './config'
import {
  UsersApi as UsersApiGen,
  UserProfileApi,
  OrgsApi,
  NavbarApi as NavbarApiGen,
  DashboardsApi as DashboardsApiGen,
  RolesApi as RolesApiGen,
} from './gen/admin-console'

export const AdminConsoleUsersApi = new UsersApiGen(AdminConsoleApiConfiguration)
export const AdminConsoleUserProfileApi = new UserProfileApi(AdminConsoleApiConfiguration)
export const AdminConsoleOrgsApi = new OrgsApi(AdminConsoleApiConfiguration)
export const AdminConsoleNavbarApi = new NavbarApiGen(AdminConsoleApiConfiguration)
export const AdminConsoleDashboardsApi = new DashboardsApiGen(AdminConsoleApiConfiguration)
export const AdminConsoleRolesApi = new RolesApiGen(AdminConsoleApiConfiguration)
